import { fromBase64 } from '@change-corgi/core/base64';

export const dataUriToBlob = (dataUri: string): Blob => {
	// convert base64/URLEncoded data component to raw binary data held in a string
	const byteString = dataUri.split(',')[0].includes('base64')
		? fromBase64(dataUri.split(',')[1])
		: unescape(dataUri.split(',')[1]);

	// separate out the mime component
	const mimeString = dataUri.split(',')[0].split(':')[1].split(';')[0];

	// write the bytes of the string to a typed array
	const ia = new Uint8Array(byteString.length);
	for (let i = 0; i < byteString.length; i += 1) {
		ia[i] = byteString.charCodeAt(i);
	}
	return new Blob([ia], { type: mimeString });
};

export const dataUriToBlobAsync = async (dataUri: string): Promise<Blob> => {
	// oxlint-disable-next-line promise/avoid-new
	return new Promise((resolve, reject) => {
		try {
			const byteString = dataUri.split(',')[0].includes('base64')
				? atob(dataUri.split(',')[1])
				: unescape(dataUri.split(',')[1]);

			// separate out the mime component
			const mimeString = dataUri.split(',')[0].split(':')[1].split(';')[0];

			// write the bytes of the string to a typed array
			const ia = new Uint8Array(byteString.length);
			for (let i = 0; i < byteString.length; i += 1) {
				ia[i] = byteString.charCodeAt(i);
			}

			resolve(new Blob([ia], { type: mimeString }));
		} catch (error) {
			reject(new Error('Could not convert data URI to Blob'));
		}
	});
};
